var rich_content_viewer_default = {
  "fontElementMap": "yuvlW",
  "wrapper": "mS6p9",
  "pluginContainerMobile": "WQZ-T",
  "viewer": "o-hRU",
  "android": "cjlQf",
  "rootedTraversedContent": "_8xhx9",
  "atomic": "Us-2S",
  "toolbar": "bKuNi",
  "block": "f-a59"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
